import { Play } from 'lucide-react';
import React from 'react';
import { FadeInImage } from './components/FadeInImage';

const YoutubeEmbed = ({ embedId, title }) => (
  <a
    href={`https://www.youtube.com/watch?v=${embedId}`}
    target="_blank"
    rel="noopener noreferrer"
    style={{
      textDecoration: 'none',
    }}
  >
    <FadeInImage
      src={`https://img.youtube.com/vi/${embedId}/hqdefault.jpg`}
      alt={title || 'YouTube thumbnail'}
      onLoad={() => {}}
      onError={() => {}}
    />
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        display: 'inline-block',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.55)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Play
            style={{ transition: 'all .25s ease' }}
            size={32}
            color="currentColor"
            fill="currentColor"
          />
        </div>
      </div>
    </div>
  </a>
);

export default YoutubeEmbed;
